export default __webpack_public_path__ + "static/media/logo.7db0b88b.svg";